import { useLocation, useSearchParams } from 'react-router-dom';
import StudyBreadcrumbs from './StudyBreadcrumbs';

export default function ThematicStudiesLayoutBreadcrumbs() {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const query = searchParams.get('q')?.trim();
    const tag = searchParams.get('tag')?.trim();

    // Tag search only exists on the /thematic-studies index page, so a stray
    // ?tag= on a theme/topic URL (e.g. browser history, a hand-edited link)
    // must not hide breadcrumb navigation there - it does nothing on those pages.
    const segments = location.pathname.split('/').filter(Boolean);
    const isIndexPage = segments.length <= 1;

    if (query || (tag && isIndexPage)) return null;
    return <StudyBreadcrumbs />;
}
